module.exports = __webpack_public_path__ + "img/symbol_2.a910562d.png";